// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w8m6N"};